export const CLIENTS_IMPORT_TEMPLATE_CSV = [
    'Client ID,Client name,Client type,First name,Last name,Email,Phone',
    ',Northwind Traders,Business,Jane,Doe,jane@northwind.com,+15551234567',
    ',Northwind Traders,Business,Sam,Lee,sam@northwind.com,+15551234568',
    ',Dana Park,Individual,Dana,Park,dana@gmail.com,+15551239999'
].join('\n');
export const CLIENTS_IMPORT_TEMPLATE_CSV_WITH_ROLE = [
    'Client ID,Client name,Client type,First name,Last name,Email,Phone,Role',
    ',Northwind Traders,Business,Jane,Doe,jane@northwind.com,+15551234567,Owner',
    ',Northwind Traders,Business,Sam,Lee,sam@northwind.com,+15551234568,Member',
    ',Dana Park,Individual,Dana,Park,dana@gmail.com,+15551239999,Reviewer'
].join('\n');
export const CLIENTS_IMPORT_TEMPLATE_FILENAME = 'anchor-import-clients-template.csv';
